import { useCallback, useId, useState } from 'react'
import { CancellationPolicyModal } from '~/components/shared/CancellationPolicyModal/CancellationPolicyModal'
import { ShowPoliciesByProductType } from '~/components/shared/CancellationPolicyModal/CancellationPolicyModal.types'
import { CancellationModalContext } from './types'

const useCancellationPolicyModal = (
  policies: ShowPoliciesByProductType
): CancellationModalContext => {
  const [isOpen, setIsOpen] = useState(false)

  const onOpen = useCallback(() => {
    setIsOpen(true)
  }, [])

  const onClose = useCallback(() => {
    setIsOpen(false)
  }, [])

  const id = useId()
  const modalId = `cancellation-policy-modal-${id}`
  const isAnyPoliciesToShow =
    policies && Object.values(policies).some((policy) => Boolean(policy?.show))

  return {
    modalId,
    isOpen,
    openCancellationPolicyModal: onOpen,
    CancellationPolicyModal: isAnyPoliciesToShow ? (
      <CancellationPolicyModal
        isOpen={isOpen}
        onClose={onClose}
        policiesToShow={policies}
        id={modalId}
      />
    ) : null,
  }
}

export default useCancellationPolicyModal
